<div class="widget" [ngClass]="{'loader-shown': loadingPosts}">
  <div class="widget-loader widget-loader-forum">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-right-icon"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element heading-loading"></div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
            <tr>
              <td>
                <div class="loader-element"></div>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="loader-element"></div>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="loader-element"></div>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="loader-element"></div>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
              <td>
                <div class="loader-element"></div>
              </td>
            </tr>
        </tbody>
    </table>
    </div>
  </div>
  <div class="widget-content">

    <div class="header">
      <span class="custom-icon">
        <span class="icon material-icons">recent_actors</span>
      </span>
      <span class="title">Forums</span>
      <a routerLink="/forums">
        <span>Show All Posts</span>
        <span class="icon material-icons">open_in_new</span>
      </a>
    </div>
    
    <div class="posts">
      <table>
          <thead>
              <tr>
                  <th>Post</th>
                  <th>Category</th>
                  <th>Replies</th>
                  <th>Views</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let post of posts">
                  <td>
                      <div class="post">
                          <div class="content">
                              <span class="icon material-icons pinned" *ngIf="post.isPinned" pTooltip="Pinned">push_pin</span>
                              <a class="text {{ post.allRead.includes(ssoUser.uid) ? 'visited' : '' }}" routerLink="/forums/{{post.id}}">{{ post.title }}</a>
                          </div>
                          <span class="author">{{ post.createdByName }}, {{ post.createdAt | utcToCompTime: 'fullDateTime' }}</span>
                      </div>
                  </td>
                  <td>
                      <div class="category" [ngStyle]="{ 'background-color': post.category.color }">{{ post.category.name }}</div>
                  </td>
                  <td>{{ post.nonHiddenCommentCount ?? 0 }}</td>
                  <td>{{ post.seenCount || 0 }}</td>
              </tr>
          </tbody>
      </table>
      <div class="empty-posts" *ngIf="posts.length === 0 && !loadingPosts">
          Nothing to show here yet.
      </div>
    </div>

  </div>
</div>